// FILE: src/store/Slices/LocationSlice.js (NEW FILE)

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedCountry: "",
    selectedTimezone: "",
};

const locationSlice = createSlice({
    name: "location",
    initialState,
    reducers: {
        setCountry(state, action) {
            state.selectedCountry = action.payload;
        },
        setTimezone(state, action) {
            state.selectedTimezone = action.payload;
        },
    }
});

export const { setCountry, setTimezone } = locationSlice.actions;
export default locationSlice.reducer;